"use client";
import {
  useTagContext
} from "./F6GOJSFF.js";
import {
  useCompositeStoreProps
} from "./WH6Q5C3D.js";
import {
  usePopoverStoreProps
} from "./GO53B7AR.js";
import {
  useStore,
  useStoreProps
} from "./DTNGDFNU.js";
import {
  useUpdateEffect
} from "./OPTPHWV7.js";
import {
  __spreadProps,
  __spreadValues
} from "./4R3V3JGP.js";

// src/combobox/combobox-store.ts
import * as Core from "@ariakit/core/combobox/combobox-store";
function useComboboxStoreProps(store, update, props) {
  useUpdateEffect(update, [props.tag]);
  useStoreProps(store, props, "value", "setValue");
  useStoreProps(store, props, "selectedValue", "setSelectedValue");
  useStoreProps(store, props, "resetValueOnHide");
  useStoreProps(store, props, "resetValueOnSelect");
  return Object.assign(
    useCompositeStoreProps(
      usePopoverStoreProps(store, update, props),
      update,
      props
    ),
    { tag: props.tag }
  );
}
function useComboboxStore(props = {}) {
  const tag = useTagContext();
  props = __spreadProps(__spreadValues({}, props), {
    tag: props.tag !== void 0 ? props.tag : tag
  });
  const [store, update] = useStore(Core.createComboboxStore, props);
  return useComboboxStoreProps(store, update, props);
}

export {
  useComboboxStoreProps,
  useComboboxStore
};
